
import Box from '@mui/material/Box';
import EDTypography from '../Typography/EDTypography';
import { IRapportAddressWindowControl } from './RapportMallTypes';
import { MM_TO_PIXEL_SCALE, SELECTED_SHADOW } from './RapportMallUtils';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';

interface IProps {
  ctrl: IRapportAddressWindowControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportAddressWindowControl) => void;
  controlPath: number[];
  selected?: boolean;
  pageMarginLeft: number;
  pageMarginTop: number;
}

const WIN_WIDTH = 100;
const WIN_HEIGHT = 35;
const WIN_X = 104;
const WIN_Y = 38;
const MARGIN_X = 10; // C5: 229mm x 162mm   => 19mm horizontal diff
const MARGIN_Y = 7; // A5: 210mm x 148.5mm => 13.5mm vertical diff

export const RapportAddressWindow: React.FC<IProps> = props => {
  const { ctrl, sx, onMouseEnter, onMouseLeave, selected } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        position: 'absolute',
        left: (WIN_X + MARGIN_X - props.pageMarginLeft) * MM_TO_PIXEL_SCALE,
        top: (WIN_Y + MARGIN_Y - props.pageMarginTop) * MM_TO_PIXEL_SCALE,
        width: (WIN_WIDTH - MARGIN_X * 2) * MM_TO_PIXEL_SCALE,
        height: (WIN_HEIGHT - MARGIN_Y * 2) * MM_TO_PIXEL_SCALE,
        boxSizing: 'border-box',
        overflow: 'hidden',
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      <EDTypography variant="body2">{ctrl.Address}</EDTypography>
    </Box>
  );
};

interface IRapportAddressWindowEditProps {
  value: IRapportAddressWindowControl;
  onChange: (ctrl: IRapportAddressWindowControl) => void;
}

export const RapportAddressWindowEdit: React.FC<
  IRapportAddressWindowEditProps
> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
    <RapporteditorTextField
      label="Adress"
      field="Address"
      value={props.value}
      onChange={props.onChange}
      allowModelSelect
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={!!props.value.Editable}
          onChange={e =>
            props.onChange({ ...props.value, Editable: e.target.checked })
          }
        />
      }
      label="Redigerbar"
      sx={{ mb: 2 }}
    />
  </Box>
);
